import { memo, useRef, useCallback } from 'react';
import { View, StyleSheet } from 'react-native';
import { THEME, COLOR, FONT, SELECT_STYLE_ROUND } from '../../constants/styles';
import { I18n, Navigation } from '../components';
import Select from 'react-select';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { changeCurrentCase } from './actions';
import { getSortedCasesArray, getCurrentEmployer } from '../../selectors/entities';
import { setCalendarViewEmployer } from '../calendar/actions';

function mapStateToProps(state, ownProps) {
  const cases = getSortedCasesArray(state);
  const currentEmployer = getCurrentEmployer(state);

  let currentCase = null;

  // map the redux state into props that our Select wants to receive
  const caseOptions = [];
  // if the user can see all the resident make this the first option
  if (ownProps.canSeeAllResidentsOption) {
    caseOptions.push({
      label: I18n.aec('allResidents'),
      id: -1,
    });
  }
  if (currentEmployer) {
    caseOptions.push({
      label: I18n.aec('searchResidents'),
      id: -2,
    });
  }
  if (cases && cases.length > 0) {
    caseOptions.push(
      ...cases.map((caseItem) => {
        const label = caseItem.name;
        const opt = {
          label,
          id: caseItem.caseId,
        };

        // check if this caseOption is the current one
        if (opt.id === state.application.currentCaseId) {
          currentCase = { ...opt };
        }

        return opt;
      })
    );
  }

  currentCase = ownProps.showAllResidents ? caseOptions[0] : currentCase;

  return {
    caseOptions,
    currentCase,
    caseCount: Object.keys(state.entities?.cases || {}).length || 0,
    currentEmployer,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        changeCurrentCase,
        setCalendarViewEmployer,
      },
      dispatch
    ),
  };
}

function SelectCaseBtn(props) {
  function handleCaseSelect({ id }) {
    if (id === -1) {
      props.actions.setCalendarViewEmployer(true);
    } else if (id === -2) {
      // launch the search
      Navigation.showModal({
        screen: 'SelectCaseEmployer',
        title: I18n.aec('searchResidents'),
        passProps: { airmenOnly: true },
        options: { width: 400 },
      });
    } else {
      if (props.canSeeAllResidentsOption) {
        props.actions.setCalendarViewEmployer(false);
      }
      props.actions.changeCurrentCase(id);
    }
  }

  return (
    <View style={[styles.caseSelectContainer, props.containerStyle]}>
      <Select
        styles={SELECT_STYLE_ROUND}
        options={props.caseOptions}
        onChange={handleCaseSelect}
        placeholder={I18n.t('case.activeCase')}
        value={props.currentCase}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  caseSelectContainer: {
    width: 200,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectCaseBtn);
